import { theme } from '@/components/features/theme/theme';
import styled from 'styled-components';

export const StyledInnerBannerDetailsSub = styled.section`
	padding-top: calc(700 / 1366 * 100%);
	position: relative;
	background-color: #ddd;
	z-index: 1;
	@media (min-width: 768px) {
		margin-bottom: ${props => props.getHeight / 2}px;
	}
	&.forMobileOne {
		padding: 0;
	}

	&.solution {
	}

	.banner-links {
		li {
			a {
				color: white;
				text-decoration: underline;
			}
		}
	}
	.video__inner {
		height: 100%;
		// position: relative;
		// background-color: ${text};
		video {
			position: absolute;
			height: 100%;
			width: 100%;
			object-fit: cover;
			inset: 0;
		}
	}

	.icon {
		position: absolute;
		right: 30px;
		top: 30px;
		@media (max-width: 767px) {
			position: relative;
			inset: unset;
			margin-bottom: 20px;
		}
	}

	.inner-banner-details {
		position: absolute;
		left: 0;
		right: 0;
		z-index: 3;
		bottom: 0;
		padding: 80px 0;
		width: calc(100% - ${props => props.offset + 15}px);
		border-top-right-radius: 5px;
		border-bottom-right-radius: 5px;
		overflow: hidden;
		background: #152637;
		transform: translateY(50%); /* Centers the box horizontally */

		.fixed-right-Inner {
			position: absolute;
			right: 0;
			bottom: 0;
		}
		.container {
			position: relative !important;
			inset: unset !important;
			width: 100%;
			max-width: 100%;
			padding: 0;
			margin: 0;

			&:after {
				display: none;
			}

			p {
				color: #fff;
				font-size: 1rem; /* 16px / 16 */
				font-style: normal;
				font-weight: 400;
				line-height: 1.5rem; /* 24px / 16 = 1.5 */
			}

			h3 {
				color: #fff;
				font-size: 3.25rem; /* 52px / 16 */
				font-style: normal;
				font-weight: 400;
				line-height: 3.75rem; /* 60px / 16 */
				letter-spacing: -0.1625rem; /* -2.6px / 16 */
				margin-bottom: 20px;
			}
		}

		@media (max-width: 767px) {
			padding: 40px 0;

			position: relative;
			transform: unset;
			width: 100%;
			h3 {
				margin-bottom: 40px;
			}
		}
	}

	&.forImageScroll {
		//padding-top: calc(560 / 1366 * 100%);
	}

	@media (max-width: 992px) and (min-width: 768px) {
		&.for_projects {
			padding-top: calc(671 / 1366 * 100%);
		}

		padding-top: calc(760 / 1366 * 100%);
	}

	&:after {
		content: '';
		position: absolute;
		background: #0000007a;
		height: 100%;
		width: 100%;
		left: 0;
		top: 0;
	}

	&.for_projects {
		.container {
			bottom: unset;
			top: 50%;
			transform: translateY(-50%);
			text-align: center;

			.col-md-8 {
				flex: 0 0 100%;
				width: 100%;
				text-align: center;
			}
		}
	}

	.container {
		position: absolute;
		//height: 100%;
		//top: 0;
		margin: auto;
		left: 0;
		right: 0;
		bottom: 225px;
		z-index: 2;
		padding-top: 40px;

		@media (max-width: 767px) {
			bottom: 40px;
		}

		&:after {
			position: absolute;
			left: 0;
			right: 0;
			top: 0;
			height: 1px;
			width: calc(100% - 30px);
			background: white;
			content: '';
			margin: 0 auto;
		}

		.breadcrumb-ygen {
			display: flex;
			gap: 10px;

			li {
				font-size: 1rem; /* 16px / 16 */
				font-style: normal;
				font-weight: 500;
				line-height: 1.5rem; /* 24px / 16 */
				color: rgba(255, 255, 255, 0.5);

				a {
					font-size: 1rem; /* 16px / 16 */
					font-style: normal;
					font-weight: 500;
					line-height: 1.5rem; /* 24px / 16 */
					color: rgba(255, 255, 255, 0.5);
				}

				h1 {
					font-size: 1rem; /* 16px / 16 */
					font-style: normal;
					font-weight: 500;
					line-height: 1.5rem; /* 24px / 16 */
					color: white;
				}
			}
		}

		p {
			color: ${theme.colors.white};
			margin: 0;
			font-size: 2rem; /* 32px / 16 */
			font-style: normal;
			font-weight: 400;
			line-height: 2.25rem; /* 36px / 16 */

			i {
				font-family: 'PP Migra Italic';
				font-size: 2rem; /* 32px / 16 */
				font-style: italic;
				font-weight: 400;
				line-height: 2.25rem; /* 36px / 16 */
			}
		}
	}

	@media (max-width: 767px) {
		padding-top: calc(560 / 450 * 100%);

		.d-flex {
			margin: 20px 0 0 !important;
			justify-content: flex-start !important;
		}
	}
`;
